module.exports = __webpack_public_path__ + "es.b8f6038dac2687f7d2a3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/es.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/es.svg
// module chunks = styles